import React, { useState, useEffect } from 'react';
import AddAreas from './AddAreas';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionAreas() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [areas, setAreas] = useState([]);
    const [editingArea, setEditingArea] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [areaToDelete, setAreaToDelete] = useState(null);
    const { user } = useUser();

    const fetchAreas = async () => {
        try {
            const response = await fetch(`${server}/MgAreas`);
            const data = await response.json();
            setAreas(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los paises: ' + error,
            });        }
    };

    useEffect(() => {
        fetchAreas();
    }, []);

    const handleNewArea = () => {
        fetchAreas();
        setEditingArea(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (area) => {
        setAreaToDelete(area);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setAreaToDelete(null);
    };

    const handleDeleteArea = async () => {
        if (areaToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                const response = await fetch(`${server}/MgAreas/${areaToDelete.id}/${username}`, {
                    method: 'DELETE'
                });
                console.log(areaToDelete.id);
                if (response.ok) {
                    handleCloseDialog();
                    fetchAreas();
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Área eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el área: ' + error,
                });            }
        }
    };

    const filteredAreas = areas.filter(area => area.descripcion?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddAreas onNewArea={handleNewArea} editingArea={editingArea} />
                <div className="ln_solid" />

                <h2>Áreas Existentes</h2>

                <div className="row">
                    <div className="col-md-7 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar área"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell>Empresa</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredAreas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((area) => (
                                        <TableRow key={area.id}>
                                            <TableCell component="th" scope="row">{area.descripcion}</TableCell>
                                            <TableCell>{area.nombreEmpresa}</TableCell>
                                            <TableCell align="right">
                                                <Button onClick={() => setEditingArea(area)} color="primary" disabled={!tienePermiso('Editar Área')}>Editar</Button>
                                                <Button onClick={() => handleOpenDialog(area)} color="secondary" disabled={!tienePermiso('Eliminar Área')}>Eliminar</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredAreas.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>
                        <Dialog
                            open={openDialog}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que deseas eliminar el área seleccionada?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteArea} color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionAreas;
